/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ last4: NonNullable<unknown> }} Ai_Key_EnvInputs */

const en_ai_key_env = /** @type {(inputs: Ai_Key_EnvInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From the server environment · ends in ${i?.last4}`)
};

const de_ai_key_env = /** @type {(inputs: Ai_Key_EnvInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aus der Server-Umgebung · endet auf ${i?.last4}`)
};

/**
* | output |
* | --- |
* | "From the server environment · ends in {last4}" |
*
* @param {Ai_Key_EnvInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_env = /** @type {((inputs: Ai_Key_EnvInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_EnvInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_env(inputs)
	return en_ai_key_env(inputs)
});